import $ from 'jquery';

export default function EmailTemplate(vm) {
    this.all = function(params) {
        var url = '/email-template/list?' + $.param(params);

        return vm.get(url);
    };

    this.create = function(params) {
        var url = '/email-template/create';

        return vm.post(url, params);
    };

    this.get = function(id) {
        var url = '/email-template/detail/' + id;

        return vm.get(url);
    };

    this.tags = function(id) {
        var url = '/email-template/tags/' + id;

        return vm.get(url);
    };

    this.simulate = function(params) {
        var url = '/email-template/simulate';

        return vm.post(url, params);
    };
}